const forms = [
  {
    name: "Service",
    className: "bg-white p-4 rounded-md p-8 w-[70%] mx-auto",
    options: [
      {
        name: "Image",
        type: "upload",
        form: {
          type: "text",
          name: "image",
          placeholder: "",
          class: "",
          value: "",
          required: false,
        },
      },
      {
        name: "Name",
        type: "input",
        form: {
          type: "text",
          name: "name",
          placeholder: "Service name",
          class: "",
          value: "",
          required: true,
        },
      },
      {
        name: "Code",
        type: "input",
        form: {
          type: "text",
          name: "code",
          placeholder: "Service code",
          class: "",
          value: "",
          required: false,
        },
      },
    ],
  },
  {
    name: "Categorization",
    options: [
      {
        name: "Category",
        type: "selectandadd",
        path: "/app/services/categories/add",
        form: {
          name: "category",
          allowClear: true,
          showSearch: true,
          filterOption: false,
          placeholder: "Service Category",
          api: "get-all-service-categories",
          options: null,
          value: null,
          required: false,
        },
      },
      {
        name: "Duration (minutes)",
        type: "input",
        form: {
          type: "number",
          name: "duration",
          placeholder: "Service duration in minutes",
          value: "",
          required: false,
        },
      },
    ],
  },
  {
    name: "Description",
    options: [
      {
        name: "Description",
        type: "input",
        form: {
          type: "text",
          name: "description",
          placeholder: "Service description",
          value: "",
          required: false,
        },
      },
    ],
  },
  {
    name: "Pricing",
    options: [
      {
        name: "Cost Price",
        type: "input",
        form: {
          type: "number",
          name: "cost_price",
          placeholder: "Service cost price",
          value: "",
          required: false,
        },
      },
      {
        name: "Sale Price",
        type: "input",
        form: {
          type: "number",
          name: "sale_price",
          placeholder: "Service selling price",
          value: "",
          required: false,
        },
      },
    ],
  },
  {
    name: "Taxation",
    options: [
      {
        name: "Tax [VAT]",
        type: "select",
        form: {
          name: "tax",
          allowClear: true,
          showSearch: true,
          filterOption: false,
          placeholder: "Tax",
          api: "get-all-taxes",
          options: null,
          value: null,
          required: false,
        },
      },
    ],
  },
  {
    name: "Status",
    options: [
      {
        name: "Status",
        type: "select",
        form: {
          name: "status",
          allowClear: false,
          placeholder: "Status",
          value: 1,
          options: [
            {
              value: 1,
              label: "Active",
            },
            {
              value: 0,
              label: "In-active",
            },
          ],
          required: false,
        },
      },
    ],
  },
];

export default forms;